// Find duplicate string values in an array
export const findDuplicateStringValues = (arr: string[]): string[] => {
  const stringValues: Set<string> = new Set();
  const duplicates: Set<string> = new Set();

  for (const value of arr) {
    if (stringValues.has(value)) {
      duplicates.add(value);
    } else {
      stringValues.add(value);
    }
  }

  return Array.from(duplicates);
};

// Find duplicate values in two arrays of strings;
export const findDuplicateStringValuesFromArrays = (
  arr1: string[],
  arr2: string[]
): string[] => {
  const set1: Set<string> = new Set(arr1);
  const set2: Set<string> = new Set(arr2);
  const duplicates: Set<string> = new Set();

  for (const value of set1) {
    if (set2.has(value)) {
      duplicates.add(value);
    }
  }

  return Array.from(duplicates);
};
